import { render, staticRenderFns } from "./VehicleHistoryFormModal.vue?vue&type=template&id=eff9246a"
import script from "./VehicleHistoryFormModal.vue?vue&type=script&lang=js"
export * from "./VehicleHistoryFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports